import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isIndividualPage } from '~scenes/sport/horse-racing/utils';
import { seoUrlSport } from '~spa/Utils/SeoUrls';
import LoadingIndicator from '~spa/Components/LoadingIndicator';
import MessageButtonCard from '~spa/Components/MessageButtonCard';
import { withLazyLoadContext } from '~spa/Components/LazyLoad/LazyLoad';
import i18n from '~shared/utils/i18n';
import WidgetContainer from '~shared/ui/WidgetContainer';
import WidgetQuickLinks from '~shared/components/widget-quick-links';
import { getGaAttributeValueHomepageWidget } from '~shared/utils/google-analytics';
import TypeTabs from './TypeTabs';
import { getRaceType, getSportName, getSportSlug } from '../../utils';
import {
    BB_RACING_WIDGET_SUFFIX,
    BB_RACING_ACTION_SEE_ALL,
} from '../../constants';
import { HOMEPAGE_VARIANT_LOCATION } from '~spa/Pages/Homepage/constants';

const propTypes = {
    type: PropTypes.string,
    showHeader: PropTypes.bool,
    initRacing: PropTypes.func,
    unregisterWsUpdate: PropTypes.func,
    getSchedule: PropTypes.func,
    racingData: PropTypes.object,
    children: PropTypes.any,
    source: PropTypes.string,
    isFavouriteSport: PropTypes.bool,
    lazyLoadHasLoaded: PropTypes.func,
    lazyLoadIsEmpty: PropTypes.func,
    displayType: PropTypes.string,
    setSelectedId: PropTypes.func,
    resetMeetingData: PropTypes.func,
    isStreaming: PropTypes.bool,
    setIsStreaming: PropTypes.func,
};

const defaultProps = {
    lazyLoadHasLoaded: () => null,
    lazyLoadIsEmpty: () => null,
    isFavouriteSport: false,
};

class Racing extends React.Component {
    initialize() {
        const {
            type,
            displayType,
            lazyLoadHasLoaded,
            lazyLoadIsEmpty,
        } = this.props;
        this.props.initRacing(type, displayType, {
            lazyLoadHasLoaded,
            lazyLoadIsEmpty,
        });
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isStreaming !== prevProps.isStreaming) {
            this.props.setIsStreaming(this.props.isStreaming);
        }

        if (this.props.type !== prevProps.type) {
            this.initialize();
        }
        if (isIndividualPage(this.props.displayType) && this.props.racingData.isLoading !== prevProps.racingData.isLoading) {
            if (!this.props.racingData.isLoading) {
                this.props.setSelectedId(this.props.racingData);
            } else {
                this.props.resetMeetingData();
            }
        }
    }

    componentWillUnmount () {
        this.props.unregisterWsUpdate();
    }

    render () {
        if (!isIndividualPage(this.props.displayType) && !this.props.racingData.init) {

            return null;
        }

        if (isIndividualPage(this.props.displayType)) {
            if(this.props.racingData.isLoading) {

                return <LoadingIndicator />;
            }

            if(this.props.racingData.scheduleIsEmpty) {

                return <MessageButtonCard
                    MessageIconClassName="no-results"
                    message={i18n.t('racing.no_scheduled')}
                />;
            }
        }

        const { isFavouriteSport = false, displayType } = this.props;
        const slug = getSportSlug(this.props.racingData.sports_details);
        const translatedSlug = getSportSlug(this.props.racingData.sports_details, true);
        const gtm = `${this.props.source};${slug}${BB_RACING_WIDGET_SUFFIX};${BB_RACING_ACTION_SEE_ALL}`;
        const sportNameHeading = getSportName(this.props.racingData);

        const [ sportId ] = Object.keys(this.props.racingData.sports_details);
        const titleLink = this.props.showHeader
            ? seoUrlSport(`/${translatedSlug}`, sportId)
            : null;
        const racingwidgetClass = classNames({
            'bb-racing-widget': true,
            'bb-racing-widget__featured-page': isIndividualPage(displayType),
        });

        return (
            <div className={racingwidgetClass}>
                <WidgetContainer
                    title={this.props.showHeader
                        ? sportNameHeading
                        : null}
                    titleIconClassName={this.props.type}
                    key={`${this.props.racingData.default_event_id}-${getRaceType(this.props.racingData.featured)}`}
                    gtmAttribute={gtm}
                    gaComponent={getGaAttributeValueHomepageWidget(slug, this.props.source === HOMEPAGE_VARIANT_LOCATION)}
                    titleLink={titleLink}
                    isFavouriteSport={isFavouriteSport}
                >
                    <WidgetQuickLinks data={this.props.racingData.widgetQuickLinks} sportSlug={slug} />
                    {
                        this.props.racingData.hasFeatured && !isIndividualPage(displayType) &&
                            <TypeTabs
                                type={this.props.type}
                                racingContext={this.props.racingData}
                                scheduleUpdate={(tabIdx) => {
                                    this.props.unregisterWsUpdate();
                                    this.props.getSchedule(
                                        this.props.type,
                                        tabIdx,
                                        this.props.racingData.cachedEvents,
                                    );
                                }}
                            />
                    }
                    {this.props.children}
                </WidgetContainer>
            </div>
        );
    }
}

Racing.propTypes = propTypes;
Racing.defaultProps = defaultProps;

export default withLazyLoadContext()(Racing);
